import React from 'react';
import Typography from '@material-ui/core/Typography';
// import displayText from './displayText.json';

function PpsiIfoodDiscontinueText({ text, customStyle = {} }) {
  return (
    <div>
      <Typography
        style={{ color: '#FF0000', marginRight: '20px', ...customStyle }}
      >
        {text}
      </Typography>
    </div>
  );
}

export default PpsiIfoodDiscontinueText;
